import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { SocialLinks } from "./SocialLinks";
import { CONTACT_EMAIL } from "../lib/siteConfig";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_videocrew-ct/artifacts/ipgpa8tb_VGCT_LOGO.png";

export default function Footer() {
  const footerLinks = {
    directory: [
      { label: "Find Creatives", href: "/browse" },
      { label: "Categories", href: "/categories" },
      { label: "Locations", href: "/locations" },
      { label: "Featured Profiles", href: "/browse?featured=true" },
    ],
    resources: [
      { label: "Post a Job", href: "/post-job" },
      { label: "Job Board", href: "/jobs" },
      { label: "Pricing", href: "/pricing" },
      { label: "Advertise With Us", href: "/advertise" },
    ],
    company: [
      { label: "Create Your Profile", href: "/signup" },
      { label: "About Us", href: "/about" },
      { label: "Contact", href: "/contact" },
    ],
    legal: [
      { label: "Privacy Policy", href: "/privacy" },
      { label: "Terms of Service", href: "/terms" },
      { label: "Cookie Policy", href: "/cookies" },
      { label: "Refund Policy", href: "/refund-policy" },
    ],
  };

  return (
    <footer className="bg-zinc-950 border-t border-zinc-800" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 mb-12">
          {/* Logo & Description */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img
                src={LOGO_URL}
                alt="Videography Cape Town"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-zinc-500 text-sm mb-4 max-w-xs">
              The premier directory for film and video professionals in Cape Town. 
              Find the perfect creative talent for your next production.
            </p>
            <div className="flex items-center gap-2 text-zinc-500 text-sm">
              <MapPin className="h-4 w-4" />
              <span>Cape Town, South Africa</span>
            </div>
          </div>

          {/* Directory Links */}
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-400 mb-4">
              Directory
            </h4>
            <ul className="space-y-2">
              {footerLinks.directory.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-zinc-500 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-400 mb-4">
              Resources
            </h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-zinc-500 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-400 mb-4">
              Company
            </h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-zinc-500 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-mono text-xs uppercase tracking-widest text-zinc-400 mb-4">
              Legal
            </h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-zinc-500 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-zinc-800">
          <p className="text-zinc-600 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Videography Cape Town. All rights reserved.
          </p>
          
          {/* Social Links */}
          <div className="flex items-center gap-4">
            <SocialLinks testIdPrefix="footer-social" />
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-zinc-500 hover:text-orange-500 transition-colors"
              aria-label={`Email ${CONTACT_EMAIL}`}
              title={CONTACT_EMAIL}
              data-testid="footer-email"
            >
              <Mail className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
